import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetWebsiteDesignerVisitStatusQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  purpose?: Types.InputMaybe<Types.EventDesignPurpose>;
}>;

export type GetWebsiteDesignerVisitStatusQuery = {
  __typename?: 'Query';
  eventByName?: { __typename?: 'Event'; id: string; eventDesign?: { __typename?: 'EventDesign'; id: string; hasVisitedDesignPage?: boolean | null } | null } | null;
};

export const GetWebsiteDesignerVisitStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWebsiteDesignerVisitStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPurpose' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasVisitedDesignPage' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWebsiteDesignerVisitStatusQuery__
 *
 * To run a query within a React component, call `useGetWebsiteDesignerVisitStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteDesignerVisitStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteDesignerVisitStatusQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useGetWebsiteDesignerVisitStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>(GetWebsiteDesignerVisitStatusDocument, baseOptions);
}
export function useGetWebsiteDesignerVisitStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>(GetWebsiteDesignerVisitStatusDocument, baseOptions);
}
export type GetWebsiteDesignerVisitStatusQueryHookResult = ReturnType<typeof useGetWebsiteDesignerVisitStatusQuery>;
export type GetWebsiteDesignerVisitStatusLazyQueryHookResult = ReturnType<typeof useGetWebsiteDesignerVisitStatusLazyQuery>;
export type GetWebsiteDesignerVisitStatusQueryResult = Apollo.QueryResult<GetWebsiteDesignerVisitStatusQuery, GetWebsiteDesignerVisitStatusQueryVariables>;
